import { css } from '@emotion/css';
import editIcon from '@volumental/assets/icons/EditPenIcon.svg';
import deleteIcon from '@volumental/assets/icons/TrashBinIcon.svg';
import {
  BoxContainer,
  IconButton,
  type LabeledValue,
} from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { type SizeLocale } from '../../../api/gql/graphql';
import { uiConfig } from '../../../services/config';
import { type ResultStep } from '../../../store/survey';

const contentStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const rowStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 5px 0px 5px 16px;
`;
const shoeDetailStyle = css`
  display: flex;
  flex-direction: column;
  font-family: ${uiConfig.styles.fontFamily};
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 16px;
  line-height: 25px;
`;

export interface SelectedSize {
  size: LabeledValue<number>;
  locale: SizeLocale;
  width?: LabeledValue<number | undefined>;
}

const makeSizeString = (size: SelectedSize | undefined): string | undefined => {
  if (!size) {
    return undefined;
  }
  if (!size.width?.value) {
    return `${size.locale} ${size.size.label}`;
  }
  return `${size.locale} ${size.size.label} ${size.width.label}`;
};

interface ResultBoxProps {
  survey: ResultStep;
  onRemove?: () => void;
  onEdit?: () => void;
}
export function ResultBox({
  survey: { brand, gender, length, locale, width },
  onRemove,
  onEdit,
}: ResultBoxProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <BoxContainer applyBorder backgroundColor="white">
      <div className={contentStyle}>
        <div className={shoeDetailStyle}>
          <span style={{ fontWeight: 'bold' }}>{brand.label}</span>
          <span>{gender.label}</span>
          <span>{makeSizeString({ size: length, locale, width })}</span>
        </div>
        <div className={rowStyle}>
          {onEdit !== undefined && (
            <IconButton
              onClick={onEdit}
              iconSrc={editIcon}
              altText={t('imageAlt.editPP')}
            />
          )}
          {onRemove !== undefined && (
            <IconButton
              onClick={onRemove}
              iconSrc={deleteIcon}
              altText={t('imageAlt.removePP')}
            />
          )}
        </div>
      </div>
    </BoxContainer>
  );
}
